import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { NavBar, Icon, Toast } from 'antd-mobile'
import Component, { mapStateToProps, mapDispatchToProps } from '../components/Component'
import { connect } from 'react-redux'
import style from './MailDetail.module.less'
import { TextList, TextItem } from '../components/TextList'

function renderMobile (m) {
  if (/^\d/.test(m)) {
    return <a onClick={() => { window.location.href = `tel:${m}` }}>{m}</a>
  }
  return '无'
}

class MailDetail extends Component {
  state = {
    height: 0,
    arbitrator: {}
  }

  status = true
  containerRef = React.createRef()
  navbarRef = React.createRef()

  // 获取数据
  getData () {
    Toast.loading('数据加载中', 120)
    const id = this.props.match.params.id
    this.$get(`/api/xapc/arbitrator/${id}`)
      .then(res => {
        Toast.hide()
        if (this.status === false) {
          return false
        }
        if (res.status === 1) {
          this.setState({
            arbitrator: res.data
          })
        } else {
          Toast.fail(res.message, 2)
        }
      }).catch(() => Toast.hide())
  }

  initHeight () {
    this.setState({
      height: this.containerRef.current.offsetHeight - ReactDOM.findDOMNode(this.navbarRef.current).offsetHeight
    })
  }

  componentDidMount () {
    this.initHeight()
    this.getData()
  }

  componentWillUnmount () {
    this.status = false
  }

  render () {
    const a = this.state.arbitrator
    return (
      <div ref={this.containerRef} className={style.container}>
        <div className={style.header}>
          <NavBar ref={this.navbarRef} mode='light' icon={<Icon type='left' size='lg' />} onLeftClick={() => this.props.history.goBack()}>仲裁员详情</NavBar>
        </div>
        <div className={style.detail} style={{ height: this.state.height + 'px' }}>
          <TextList>
            <TextItem title='姓名' value={a.name || '无'} />
            <TextItem title='手机号码' value={renderMobile(a.mobile)} />
            <TextItem title='所在地' value={a.area || '无'} />
            <TextItem title='职业' value={a.occupation || '无'} />
            <TextItem title='专业' value={a.cause_action || '无'} />
            <TextItem title='单位' value={a.structure || '无'} />
            <TextItem title='单位电话' value={renderMobile(a.structure_tel)} />
            <TextItem title='是否在职' value={a.status || '无'} />
          </TextList>
        </div>
      </div>
    )
  }
}

MailDetail.propTypes = {
  goBack: PropTypes.func,
  id: PropTypes.string
}

MailDetail.defaultProps = {
  goBack: () => {},
  id: ''
}

const mapState = mapStateToProps(function (state) {
  return {
    userInfo: state.basic.userInfo
  }
})

const mapDispatch = mapDispatchToProps(function (dispatch) {
  return {

  }
})

export default connect(mapState, mapDispatch)(MailDetail)
